export default __webpack_public_path__ + "static/media/check.a1a75f1c.svg";